import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  formContainer: {},
  blueColor: {
    color: '#206BDF',
  },
}));
